import React, { useState } from 'react';
import Product from '../Product';
import {ProductGroup, NeuroMessage, ProductPagePropTypes, usePages, contact} from '@ignitesales/neuro-application/src/neuro-guide';
import { AnswersList } from '@ignitesales/neuro-application/src/neuro-guide/guide-framework';
import { useUser } from '@ignitesales/neuro-application/src/neuro-guide/hooks';
import { sendResultsViaEmail, useDispatch } from '@ignitesales/neuro-application/src/neuro-guide/state';
import Collapsible from 'react-collapsible';
import ReactSVG from "react-svg";


function DetailsPage({ componentClass, product, productGroups }) {
  const { goToPreviousPage } = usePages();
  const { uuid } = useUser();
  const [ leadTransmitted, setLeadTransmitted ] = useState(false);
  const dispatch = useDispatch();
  const date = new Date();


  const renderProductGroup = (productGroup, subGroups, products) => {
    const cssBEM = 'product-group';

    return products.length ?
      <div className={cssBEM} key={ productGroup.name }>
        <div className={ `${ cssBEM }__container` } key={ productGroup.name }>
          <div className={ `${ cssBEM }__header count-${ products.length || 0 }` }>
            <h1><NeuroMessage id={ `productGroup.${ productGroup.name }` } tagName="span"/></h1>
          </div>
          { subGroups || null }
          { products || null }
        </div>
      </div> : null;
  };

  const onProductClick = (params) => {
    setSelectedProduct(params);

    if(leadTransmitted) {
      setShowSuccessFormModal(true);
    } else {
      setShowContactFormModal(true);
    }
  };


  const renderProduct = (product) => {
    return <Product
      key={ product.id }
      product={ product }
      onClick={ onProductClick }
      isDetailsPage={ true }
    />;
  };

  return (
    <div className={componentClass}>
      <div className={ `${ componentClass }__header` }>
        <div className={ `${ componentClass }__header--container` }>
          <NeuroMessage id="summary.header" tagName='h1' />
        </div>
      </div>

      <div className={ `${ componentClass }__uuidMessage` }>
        <NeuroMessage id="summary.uuidMessage" tagName='p' values={{ uuid: uuid, date: date.toDateString() }} />
      </div>

      <div className={ `${ componentClass }__products` }>{ productGroups.map(g =>
        <ProductGroup group={ g } renderGroupFn={ renderProductGroup } renderProductFn={ renderProduct } key={ g.name } />
      )}
      </div>

      <div className={ `${ componentClass }__answers` }>
        <Collapsible
          classParentString="collapsible"
          className={`${ componentClass }__answer-collapsible`}
          openedClassName={`${ componentClass }__answers-collapsible--open`}
          open={ true }
          trigger={
            <NeuroMessage id="summary.answers" tagName='h2' />
          }>
          <AnswersList />
        </Collapsible>
      </div>

      <div className={ `${ componentClass }__navigation` }>
        <button onClick={goToPreviousPage} className="btn btn-secondary"><NeuroMessage id="nav.prev"/></button>
      </div>
      <div className={ `${ componentClass }__footer` }>
      <div>© {new Date().getFullYear()} <NeuroMessage id="summary.footer" tagName='p'/></div>
        <ReactSVG src="/classpath/assets/images/equal-housing-logo.svg" />
      </div>
    </div>
  );
}

DetailsPage.propTypes = ProductPagePropTypes;

export default DetailsPage;
